<script>
    export let data = "";

    let isShowInfo = true;

    // HELPER FUNCTIONS
    const _toggleShowHideDetails = () => (isShowInfo = !isShowInfo);

    const _getDisplayDataText = (text) => {
        return text
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;")
            .replace(/&#039;/g, "'");
    };
</script>

<div
    class={`transition flex flex-col w-full lg:flex-row ${
        isShowInfo ? "" : "max-h-[50px]"
    }`}
>
    <div
        class="flex-1 h-full card bg-white rounded-box border"
    >
        <div
            class="flex justify-between pr-4 text-white cursor-pointer bg-gradient-to-b from-bg-primary to-bg-secondary"
            on:click|preventDefault={_toggleShowHideDetails}
        >
            <p class="font-bold px-2 py-4">Exception Data</p>
        </div>

        <div class="flex flex-col flex-1 px-2 py-4 w-full lg:flex-row">
            <div class="flex flex-col flex-1 gap-y-4 h-full">
                <div class="flex flex-row gap-x-2">
                    {#if data}
                        <pre
                            class="ml-3 pr-3 whitespace-pre-wrap font-sans break-words">{_getDisplayDataText(
                                data
                            )}</pre>
                    {:else}
                        <p class="content">No exception data</p>
                    {/if}
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .content {
        width: calc(100% - 150px);
    }

    .transition {
        transition: 0.5s linear;
    }
</style>
